module.exports = __webpack_public_path__ + "static/img/fire_scorpion.137e5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/fire_scorpion.png
// module id = eFer
// module chunks = 0